<template>
  <div class="Div">
    <section class="sectionContent">
      <labars-bread></labars-bread>
      <div class="details">
        <p class="title">
          {{details.article_title_cn}}
        </p>
        <div class="author">
          <span>
            {{details.send_time}}
          </span>
          <span>

            {{details.sourceTitle}}：{{details.article_source_cn}}
          </span>
        </div>
        <div
          class="contents"
          v-html="details.article_content_cn"
        >

        </div>
        <div
          class="annex"
          v-if="details.fileList.length>0"
        >
          附件下载：
          <a
            v-for="(item,i) of details.fileList"
            :key="i"
            :href="item.enclosure_url"
            :download="item.enclosure_name"
            class="a"
          >{{item.enclosure_name}}</a>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import LabarsBread from "../../layout/LabarsBread";
import { articleDetails } from "../../api/Overview";
export default {
  name: "NewsDetails",
  data() {
    return {
      laber: [],
      details: {fileList:[]}
    };
  },
  components: {
    LabarsBread
  },
  created() {
    var id = this.$route.query.id;
    articleDetails({ article_id: id }).then(res => {
      // console.log(res.data);
      this.details = res.data;
    });
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  min-height: 100%;
  background: #f5f5f5;
}
.sectionContent {
  width: px2Rem(1300px);
  margin: auto;
  padding: 0.1px 0;
  .details {
    // height: px2Rem(1160px);
    margin-bottom: px2Rem(80px);
    background: rgba(255, 255, 255, 1);
    .title {
      padding: px2Rem(26px) px2Rem(26px) px2Rem(16px);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .author {
      padding-bottom: px2Rem(17px);
      border-bottom: 1px solid rgba(237, 236, 236, 1);
      font-size: px2Rem(16px);
      // font-family:STXinwei;
      font-weight: 400;
      color: rgba(102, 102, 102, 0.5);
      text-align: center;
      span {
        display: inline-block;
        margin-right: px2Rem(15px);
        vertical-align: top;
      }
    }
    .contents {
      padding: px2Rem(37px) px2Rem(30px) px2Rem(28px);
      font-size: px2Rem(24px);
      /deep/ img {
        display: block;
        max-width: 100%;
        margin: px2Rem(40px) auto;
      }
      /deep/ video{
        max-width: 100%;
        margin: px2Rem(40px) auto;
        background: #222;
      }
    }
    .annex {
      padding: 0 px2Rem(30px) px2Rem(30px);
      a{
        margin: 0 px2Rem(10px);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/NewsDetails.vue